<template>

  <div>
    <h2 class="mb-4">{{ $t("contact") }}</h2>

    <div class="row">
       <div class="col-12" v-if="v$.reservation.contact.salutation.$error"><label class="invalid-feedback">{{ $t("inputRequired") }}</label></div>
      <div class="col-6">
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="m" name="male" value="m" v-model="reservation.contact.salutation" />
            <label class="form-check-label" for="m">{{
                $t("mr")
            }}</label>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="f" value="f" v-model="reservation.contact.salutation" />
            <label class="form-check-label" for="f">{{ $t("ms") }}</label>
          </div>
        </div>
      </div>
    </div>
  

 <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="label" for="street">{{ $t("title") }}</label>
          <input class="form-control" type="text" name="title" id="title" v-model="reservation.contact.title" />

        </div>
      </div>
  </div>



    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="label" for="firstname">{{ $t("firstname") }}</label>
          <input class="form-control" type="text" name="firstname" id="firstname"  v-model="reservation.contact.firstname" />
          <label class="invalid-feedback" for="firstname" v-if="v$.reservation.contact.firstname.$error">{{ $t("inputRequired") }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label" for="lastname">{{ $t("lastname") }}</label>
          <input class="form-control" type="text" name="lastname" id="lastname" required
            v-model="reservation.contact.lastname" />
            <label class="invalid-feedback" for="lastname" v-if="v$.reservation.contact.lastname.$error">{{ $t("inputRequired") }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="label" for="email">{{ $t("email") }}</label>
          <input class="form-control" type="email" name="email" id="email" v-model="reservation.contact.email"/>
           <label class="invalid-feedback" for="email" v-if="v$.reservation.contact.email.$error">{{ $t("emailRequired") }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label" for="telnumber">{{ $t("tel") }}</label>
          <input class="form-control" type="text" name="telnumber" id="telnumber"
            v-model="reservation.contact.telnumber" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="label" for="street">{{ $t("street") }}</label>
          <input class="form-control" type="text" name="street" id="street" v-model="reservation.contact.street" />
           <label class="invalid-feedback" for="street" v-if="v$.reservation.contact.street.$error">{{ $t("inputRequired") }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label" for="zip">{{ $t("zip") }}</label>
          <input class="form-control" type="text" name="zip" id="zip" required v-model="reservation.contact.zip" />
          <label class="invalid-feedback" for="zip" v-if="v$.reservation.contact.zip.$error">{{ $t("inputRequired") }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label" for="city">{{ $t("city") }}</label>
          <input class="form-control" type="text" name="city" id="city" required v-model="reservation.contact.city"/>
          <label class="invalid-feedback" for="city" v-if="v$.reservation.contact.city.$error">{{ $t("inputRequired") }}</label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label class="label" for="country">{{ $t("country") }}</label>
          <select name="country" class="form-select" id="country" required v-model="reservation.contact.country">
            <option :value="country.code" v-for="country in countryList" :key="country.code">
              {{ country.name }}
            </option>
          </select>
          <label class="invalid-feedback" for="country" v-if="v$.reservation.contact.country.$error">{{ $t("inputRequired") }}</label>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="label" for="comment">{{ $t("comment") }}</label>
          <textarea cols="50" rows="10" class="form-control" name="comment" id="comment" v-model="reservation.contact.comment" placeholder="Was möchten Sie uns mitteilen?"></textarea>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" name="newsletter" id="newsletter"  v-model="reservation.newsletter" />
        <label class="form-check-label" for="newsletter">
          <label class="invalid-feedback" for="newsletter" ></label>
          <div class="gtp" v-html="$t('newsletter')"></div>
        </label>
      </div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" name="gtb" id="gtb"  v-model="reservation.gtb" />
        <label class="form-check-label" for="gtb">
          <label class="invalid-feedback" for="gtb" v-if="v$.reservation.gtb.$error">{{ $t("inputRequired") }}</label>
          <div class="gtp" v-html="$t('gtp')"></div>
        </label>
      </div>
    </div>
  </div>
  <!-- START guest data for each room, adults and children -->
  <div class="form-group">
    <div class="row">
      <div class="col-sm">
        <p class="mb-0 mt-2">{{ $t("guest-information") }}</p>
      </div>
      <div class="col-sm-auto mt-2">
        <button class="btn btn-primary" @click="showGuest = !showGuest">
          {{ $t("guest-information-btn") }}
        </button>
      </div>
    </div>
  </div>
  <div v-show="showGuest">
    <div v-for="(room, index) in reservation.rooms" :key="index">
      <h4 class="mb-4">{{ $t("roomSelection") }} {{ index + 1 }}</h4>
      <div v-for="(adult, idx) in adultsInRoom(room.adults)" :key="'adult' + idx">
        <p>{{ idx + 1 }}. {{ $t("adult") }}</p>
        <OrderFormGuest templateversion="adult" v-model="room.adultlist[idx]"></OrderFormGuest>
      </div>
      <div v-for="(child, idx) in childrenInRoom(room.childrenages)" :key="idx">
        <p>{{ idx + 1 }}. {{ $t("child") }} </p>
        <OrderFormGuest templateversion="children" v-model="room.childrenlist[idx]"></OrderFormGuest>
      </div>
    </div>
  </div>
  <!-- END guest data for each room, adults and children -->
  <div class="row justify-content-end " style="margin-top: 50px;">
    <div class="col-12 col-md-auto">
      <button class="btn btn-primary btn-gradient btn-next" @click="submitForm ">
        {{ $t("next") }}
      </button>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import OrderFormGuest from "./OrderFormGuest.vue";

// let countries = require("../data/countriesDE.js");

let countriesDE = require("../data/countriesDE.js");
let countriesEN = require("../data/countriesEN.js");


// console.log("this.$i18n.locale");
// console.log(this.$i18n.locale);

export default {
  name: "OrderFormContact",
  props: ["value"],
  inject: ["reservation", "progress"],
  components: {
    OrderFormGuest,
  },
  data() {
    return {
      v$: useValidate(),
      temp: null,
      countryList: countriesDE,
      countriesDE: countriesDE,
      countriesEN: countriesEN,
      showGuest: false,
    };
  },
  validations() {
    return {
      reservation: {
        contact: {
          firstname: { required },
          lastname: { required },
          email: { required, email },
          street: { required },
          zip: { required },
          city: { required },
          country: { required },
          salutation: { required }
        },
        gtb: { required }
      }
    }
  },
  created() {
    // set local countrylist
    if (this.$i18n.locale == "en"){
      this.countryList = countriesEN;
    } else {
      this.countryList = countriesDE;
    }

    //this.reservation.test = 100;
    // console.log("this.progress.contact.show");
    // console.log(this.progress.contact.show);
  },
  computed(){

  },
  methods: {

    submitForm() {
      console.log(this.v$)
      this.v$.$validate() // checks all inputs
      if (!this.v$.$error) { // if ANY fail validation
        this.progress.step = 4;
        this.progress.overview.show = true;
        this.progress.contact.overview = true;
        this.progress.contact.show = false;
        // this.scrollToElement(this.progress.overview.name);
        // alert('Form successfully submitted.')
      } else {
        console.log("Form failed validation")
      }
    },
    onSubmit(values) {
      console.log(JSON.stringify(values, null, 2));
    },
    validateInput(value) {
      if (!value) {
        return 'This field is required';
      }
    },
    validateEmail(value) {
      // if the field is empty
      if (!value) {
        return 'This field is required';
      }

      // if the field is not a valid email
      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(value)) {
        return 'This field must be a valid email';
      }

      // All is good
      return true;
    },
    requiredCheck(value) {
      var requiredMessage = 'This field is required';
      if (value === undefined || value === null) return requiredMessage;
      if (!String(value).length) return requiredMessage;
      return true
    },
    minLength(number, value) {
      if (String(value).length < number) return 'Please type at least ' + number + ' characters';
      return true

    },
    adultsInRoom(n) {
      return Number(n);
    },
    childrenInRoom(n) {
      if (n === "") return null;
      return n.split(";").length;

    },
  },
};
</script>